// @core/api/endpoints/audittrail/get_chain_status.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AuditChainResponse,
} from '../../../types/audittrail';

const BASE_PATH = '/audittrail';

/**
 * Get chain status
 * Retrieves the current status and metadata of an audit chain, including integrity state and statistics.
 */
export async function GetChainStatus(
  chain_id: string,
  options?: RequestOptions
): Promise<AuditChainResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/audit/chains/:chain_id`;
  requestPath = requestPath.replace(':chain_id', encodeURIComponent(chain_id));
  const requestOptions = options;
  return client.get<AuditChainResponse>(requestPath, { ...requestOptions });
}
